"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInfoBlockGroupTitleProperty = exports.infoBlockGroupTitlePropertyDefinition = void 0;
exports.infoBlockGroupTitlePropertyDefinition = {
    view: {
        label: 'Info Block Title',
        style: 'h3',
    },
    constraints: [
        {
            name: 'maxLength',
            argument: 72,
        },
    ],
    type: 'text',
    multiple: false,
    name: 'info-block-group-title',
};
const isInfoBlockGroupTitleProperty = (prop) => {
    return prop.name === exports.infoBlockGroupTitlePropertyDefinition.name;
};
exports.isInfoBlockGroupTitleProperty = isInfoBlockGroupTitleProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5mby1ibG9jay1ncm91cC10aXRsZS5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2luZm8tYmxvY2stZ3JvdXAtdGl0bGUucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxxQ0FBcUMsR0FBRztJQUNuRCxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsa0JBQWtCO1FBQ3pCLEtBQUssRUFBRSxJQUFJO0tBQ1o7SUFDRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxXQUFXO1lBQ2pCLFFBQVEsRUFBRSxFQUFFO1NBQ2I7S0FDRjtJQUNELElBQUksRUFBRSxNQUFNO0lBQ1osUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsd0JBQXdCO0NBQ0MsQ0FBQTtBQUkxQixNQUFNLDZCQUE2QixHQUFHLENBQUMsSUFBa0IsRUFBdUMsRUFBRTtJQUN2RyxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssNkNBQXFDLENBQUMsSUFBSSxDQUFBO0FBQ2pFLENBQUMsQ0FBQTtBQUZZLFFBQUEsNkJBQTZCLGlDQUV6QyJ9